import FormattedMessage from 'I18n/components/FormattedMessage';
import { CLOSE } from '../../new-feature-onboarding/constants/OnboardingConstants';
import NewFeatureTourStep from '../../new-feature-onboarding/components/NewFeatureTourStep';
import { jsx as _jsx } from "react/jsx-runtime";
const CloseConversationTourStep = ({
  children
}) => /*#__PURE__*/_jsx(NewFeatureTourStep, {
  stepKey: CLOSE,
  header: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-thread-view.new-feature-onboarding.conversationCloseButton.header"
  }),
  children: children
});
CloseConversationTourStep.displayName = 'CloseConversationTourStep';
export default CloseConversationTourStep;